module.exports = __webpack_public_path__ + "assets/dbefa8bb9bf5b161dda5d9328e55974b.png";